import Game from '../assets/Game.jpg';
import News from '../assets/News.png';
import Text from '../assets/Text.jpg';
import comingsoon from '../assets/Coming Soon.jpg';
import './Project.css';

export const Project = () =>{
    return(
        <>
        <h2 className="abtproject">My Projects</h2>
        <div className="wrapper" id="project">
        <div className="card" style={{width:'18rem'}}>
  <img src={Text} className="card-img-top" alt="..." />
  <div className="card-body">
    <h5 className="card-title">TEXT-UTILITY </h5>
    <p className="card-text">Text-Utility can be used to Analyze your text and you can
also Modify it according to your need. You can also Analyze
No. of words or character you have in your text/sentence,
Text-To-Speak etc. Languages used in this Project are HTML,
CSS, BOOTSTRAP, JAVASCRIPT, REACT JS</p>
    <a href="https://aashish-011.github.io/Text-Utility/" className="btn btn-primary" rel="noreferrer" target="_blank" >Click Here To Visit</a>
  </div>
</div>
        <div className="card" style={{width:'18rem'}}>
  <img src={Game} className="card-img-top" alt="..." />
  <div className="card-body">
    <h5 className="card-title">TIC-TAC-TOE</h5>
    <p className="card-text">Made a 2 Player Cross-Zero Game using HTML,CSS,JS. Tic Tac Toe is traditionally played on a 3 × 3 grid. Players take turns placing a mark in one of the cells of the grid. The goal of the game is for players to position their marks so that they make a continuous line of three cells vertically, horizontally, or diagonally</p>
    <a href="https://aashish-011.github.io/Tic-Tac-Toe-Game/" className="btn btn-primary" rel="noreferrer" target="_blank">Click Here To Visit</a>
  </div>
</div>
        <div className="card" style={{width:'18rem'}}>
  <img src={News} className="card-img-top" alt="..." />
  <div className="card-body">
    <h5 className="card-title">NEWS WORLD</h5>
    <p className="card-text">Its shows you the latest news from all categories and also
you can read news from selected categories as per your wish.
I have used react npm components like Infinite scroll, loading
bar, I tried to make this app completely Responsive.
Languages used in this Project are HTML, CSS, JAVASCRIPT,
REACT JS. It Fetches live news from News Api.</p>
  </div>
</div>
        <div className="card" style={{width:'18rem'}}>
  <img src={comingsoon} className="card-img-top" alt="..." />
  <div className="card-body">
    <h5 className="card-title">Coming Soon</h5>
    <p className="card-text">Creating React App...</p>
  </div>
</div>
</div>
        </>
)};